import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useAnimate } from 'motion/react';
import BorderImage from '@/assets/images/0-circles-dashes.svg';
import CardBack from '@/assets/images/4-final-card-back.jpg';
import CardFront from '@/assets/images/4-final-card-front-wallpaper.jpg';
import { CONFETTI_DURATION_MILLISECONDS } from './config';
import { playConfettis } from './utils';
import { Div0 } from './Div0';
import { Div1 } from './Div1';

export const Step4 = () => {
  const [scope, animate] = useAnimate();
  const [flipped, setFlipped] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });

    const enterAnimation = async () => {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      await animate('#red-card', { scale: 50, opacity: 1 }, { duration: 0 });
      await animate(scope.current, { backgroundColor: 'var(--color-grey)' }, { duration: 0 });
      await animate('#red-card', { scale: 1 }, { duration: 2, ease: 'easeInOut' });
      await animate('#red-card', { opacity: 0 }, { duration: 1, ease: 'easeInOut' });
      await animate('#red-card', { display: 'none' }, { duration: 0 });
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';

      await animate('#text', { opacity: 1 }, { duration: 1, ease: 'easeInOut' });
    };

    void enterAnimation();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const flipCard = async () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    setTimeout(() => {
      playConfettis(Date.now() + CONFETTI_DURATION_MILLISECONDS);
    }, 500);

    await animate('#text', { opacity: 0 }, { duration: 1, ease: 'easeInOut' });
    setFlipped(true);
    await animate('#text', { opacity: 1 }, { duration: 1, ease: 'easeInOut' });
  };

  return (
    <div
      ref={scope}
      className="relative min-h-dvh w-screen flex flex-col gap-8 items-center justify-center p-8 border-image-dashed"
      style={{
        backgroundColor: 'var(--color-red)', // animated to grey on mount
        borderImageSource: `url("${BorderImage}")`,
      }}
    >
      <div className="flex flex-col justify-center items-center gap-8">
        <div
          className={clsx('relative duration-500 preserve-3d transform-3d w-3/4 md:w-64 z-10', flipped && 'rotate-y-180 cursor-pointer')}
          onClick={flipped ? () => playConfettis(Date.now() + 100) : undefined}
        >
          {/* Card back (face-down) */}
          <img src={CardBack} alt=" " className="backface-hidden rounded-lg" />

          {/* Card front (face-up) */}
          <img src={CardFront} alt=" " className="absolute inset-0 backface-hidden rotate-y-180 rounded-lg" />

          <div id="red-card" className="absolute inset-0 bg-red w-full h-full rounded-lg" />
        </div>

        <div id="text" style={{ opacity: 0 }}>
          {!flipped ? <Div0 onNext={flipCard} /> : <Div1 />}
        </div>
      </div>
    </div>
  );
};
